import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthTokenService } from 'app/core/auth/auth-token.service';
import { map } from 'rxjs';

/**
 * `/` only: valid/refreshable session → dashboard, else → login.
 */
export const rootRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authTokenService = inject(AuthTokenService);

  return authTokenService.ensureValidAccessToken().pipe(
    map((authenticated) => {
      if (authenticated || authTokenService.hasValidRefreshToken()) {
        return router.createUrlTree(['/dashboard']);
      }
      return router.createUrlTree(['/login']);
    })
  );
};
